import { isLocalhost } from 'Lib/is-localhost/is-localhost';

const gulpReplacer = '/eksmo/_verstka';

export class Livelib {
    constructor(id) {
        this._id = id;
    }

    initialRating() {
        const url = isLocalhost()
            ? `${gulpReplacer}/ajax/livelib/rating.json`
            : `/ajax/livelib/?isbn=${this._id}`;

        return fetch(url, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
        })
            .then((data) => {
                if (data.ok) {
                    return Promise.resolve(data.json());
                }

                return Promise.reject(new Error(`Ошибка: ${data.status}`));
            })
            .then((data) => ({
                average: data.MESSAGE.avg_mark.toFixed(1),
                count: data.MESSAGE.count_marks,
                counts: {
                    count1: data.MESSAGE['1_mark'],
                    count2: data.MESSAGE['2_mark'],
                    count3: data.MESSAGE['3_mark'],
                    count4: data.MESSAGE['4_mark'],
                    count5: data.MESSAGE['5_mark'],
                },
            }));
    }

    getReviewsHtml() {
        const url = isLocalhost()
            ? `${gulpReplacer}/ajax/twig/site/book/reviews-livelib/twig.php`
            : `/ajax/livelib/reviews/?isbn=${this._id}`;

        return fetch(url, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((data) => {
                if (data.ok) {
                    return Promise.resolve(data.text());
                }

                return Promise.reject(data);
            })
            .then((data) => data);
    }
}